import md5 from 'md5';

let dndpDefault = {
  url: "",
  debug: {},
  directory: "",
  items: {},
  names: [],
  el: {
      cp: ".spoint",
      // cp: ".pm__point",
      action: ".pm__rut",
      reward: "#popup_reward",
      inform: "#popup_inform",
      informContent: ".pm__inform-text",
      rewardContainer: "#rewardContainer",
  },
  variable: {
      spinable: true,
      urlGet: "",
      urlSave: "",
      methodGet: "",
      methodSave: ""
  },
  callback: function () { },
};

var temp = -1;
var angleInDegrees = 0;
var angleObj = {
angle: angleInDegrees
};
var ket_qua;

const dndPromotion = function (options) {
  let defaults = dndpDefault;
  var settings = $.extend(defaults, options);

  let _CheckSO = "";
  let Key128Bytesold = "";
  var DataKey128 = "";
  let cp = parseInt($(settings.el.cp).html());

  const closeAllPopup = () => {
      $(".popup").removeClass("active");
  };

  const activePopup = (id) => {
      $(id).addClass("active");
  };

  const informError = (content) => {
      $(settings.el.informContent).html(content);
      activePopup(settings.el.inform);
  };

  const nameToSrc = (name) => { 
      return `${settings.directory}/${name}.${settings.items.type}`;
  };

  const getAwardID = (code) => {
      return settings.items[code];
  };

  const makePrize = response => {

    var Key128 = response.split("=");
    var _Data = Key128[1];
    DataKey128 += _Data;
    var index = parseInt(_Data.charAt(127));

    var count_start = _Data.substr(index + 39, 4);

    var AC = _Data.substr(index + 32, 1);
    // var AC = 'A';
    console.log(AC);
    var _Code = _Data.substr(index + 33, 6);

    var _Encry1 = _Data.substr(index, 32);
    var _Encry2 = md5(_Encry1 + _Data.substr(index + 32, 1));
    var indexImg = getAwardID(AC);

    return {
        indexImg: indexImg,
        indexWord: AC,
        _Encry1: _Encry1,
        _Encry2: _Encry2,
        _Data: _Data,
        data: "Key32Bytes1=" + _Encry1 + "&Key32Bytes2=" + _Encry2
    };
};

  const handleData = ($this, responseData) => {
      // console.log(responseData);
      var listPrize = [];
      var data = [];

      var totalTurn = $this.hasClass("rut-1") ? 1 : 10;
      var type = $this.data("value");
      var $chest = $this.prev();
      var $item = $this.parent();

      if (totalTurn === 1) {
          var prize = makePrize(responseData);
          listPrize.push(prize);
          data = prize.data;
      } else if (totalTurn === 10) {
          for (var i = 0; i < responseData.length; i++) {
              var prize = makePrize(responseData[i]);
              listPrize.push(prize);
              data = prize.data;
          }
      }

      if (type != undefined) {
          $.ajax({
              type: settings.variable.methodSave,
              url: settings.variable.urlSave,
              dataType: "json", //or HTML, JSON, etc.,
              data: {
                  action: "save_data",
                  data: data,
                  type: type,
                  totalTurn: totalTurn,
              },
              beforeSend: function () {
              },
              success: function (data) {
                  // setTimeout(function() {
                  //     settings.apiSuccess(settings.config.countEnd,settings.config.end);
                     
                  // }, settings.config.timeApi);
                  // console.log("API success");
                  // closeAllPopup();
                  Key128Bytesold = DataKey128;
                  if (data.status === 1 && data.data === "ok") {
                      if (listPrize.length > 0) {
                          $(settings.el.rewardContainer).empty();
                          switch (listPrize.length) {
                              case 1:
                              case 10:
                                settings.animResult(listPrize);
                                  if (settings.config.animationCircle) AnimationLucky(listPrize[0].indexImg,settings.items.length)
                                  for (var i = 0, len = listPrize.length; i < len; i++) {
                                      var indexName = listPrize[i].indexImg;
                                      var imgUrl = nameToSrc(indexName);
                                      var prizeName = settings.names[indexName - 1];
                                    
                                      var template = `
                                                                            <div class="reward_item">
                                      <img class="" src="${imgUrl}" alt="${prizeName}">                                             
                                  </div> `;                                                           
                                      $(settings.el.rewardContainer).append(template);
                                      if (listPrize.length == 10) {
                                        $(settings.el.reward).addClass('gift-10')
                                      }
                                      if (listPrize.length == 5) {                                      
                                        $(settings.el.reward).addClass('gift-5')
                                      }                                    
                                  }

                                  setTimeout(function () {
                                      // custom code
                                      if ($(".pm__usedPoint").length > 0) {
                                          var usedPoint = $(".pm__usedPoint").html();
                                          usedPoint = parseInt(usedPoint);
                                          usedPoint += totalTurn;
                                          $(".pm__usedPoint").html(usedPoint);
                                      }

                                      settings.callback();
                                      activePopup(settings.el.reward);
                                      $(settings.el.action).removeClass('off')
                                  }, settings.config.timeWait);

                                  settings.variable.spinable = true;
                                  break;
                              default:
                                  closeAllPopup();
                                  informError("Error: Results not return in 1 or 5 type.");
                                  return false;
                          }

                          var totalTurn = $this.hasClass("rut-1") ? 1 : 10;
                          cp = totalTurn == 10 ? cp - 10 : cp - 1;
                          $(settings.el.cp).html(cp);
                      }
                  }
                  // LuckyDrawExchangeModule.fetchViewData();
              },
              error: function (response) {
                  settings.variable.spinable = true;
                  alert(response.data);
              },
          });
      } else {
          closeAllPopup();
          settings.variable.spinable = true;
          informError("Error: Missing data-type.");
      }

      _CheckSO = Key128Bytesold;
      if (_CheckSO == DataKey128) {
          return false;
      }
  };

  const getData = ($this) => {
      let totalTurn = $this.hasClass("rut-1") ? 1 : 10;
      let type = $this.data("value");
      var action = $this.hasClass("rut-1") ? "get_data" : "get_data_10";
      if (type != undefined) {
          $.ajax({
              type: settings.variable.methodGet,
              url: settings.variable.urlGet,
              dataType: "json",
              data: {
                  action: action,
                  type: type,
                  totalTurn: totalTurn,
              },
              beforeSend: function () {
                  // settings.getApi(settings.config.countStart,settings.config.start);
                  // $(settings.el.action).addClass('off')
                  // console.log("Get API");
              },
              success: function (response) {
                  closeAllPopup();
                  settings.variable.spinable = true;

                  if (response.status === 1) {
                      handleData($this, response.data);
                  } else {
                      informError(response.data);
                  }
              },
              error: function (response) {
                  closeAllPopup();
                  settings.variable.spinable = true;
                  informError("Vui lòng kiểm tra lại kết nối mạng để tiếp tục");
              },
          });
      } else {
          closeAllPopup();
          settings.variable.spinable = true;
          informError("Error: Missing data-type.");
      }
  };


  const main = () => {
    $(settings.el.action).on("click", function (e) {
      $(settings.el.action).addClass('off')
        e.preventDefault();
        if (settings.variable.spinable) {

            closeAllPopup();
            settings.variable.spinable = false;
            angleObj.angle = 45;
            angleInDegrees = 15;
            let totalTurn = $(this).hasClass("rut-1") ? 1 : 10;
            // if (totalTurn == 5 && $(settings.el.cp).text() < 5) {
            //     settings.variable.spinable = true;
            //     informError("Bạn chưa đủ lượt để quay nhanh x5 hoặc đã hết lượt. Vui lòng kiểm tra lại.");
            // } else if (totalTurn == 1 && $(settings.el.cp).text() < 1) {
            //     settings.variable.spinable = true;
            //     informError(settings.text.lessCp);
            // } else {
            //     getData($(this));
            // }
            if (cp >= 1 && totalTurn == 1 || cp >= 10 && totalTurn == 10) {
              angleObj.angle = 45;
              angleInDegrees = 15;
              getData($(this));
          } else {
              settings.variable.spinable = true;
              informError("Bạn đã hết lượt hoặc không đủ lượt quay.");

          }
        }
    });
};

if (settings.debug.status) {
    settings.variable.urlGet = settings.debug.getLinkTest;
    settings.variable.urlSave = settings.debug.saveLinkTest;
    settings.variable.methodGet = "GET";
    settings.variable.methodSave = "GET";
} else {
    settings.variable.urlGet = settings.url;
    settings.variable.urlSave = settings.url;
    settings.variable.methodGet = "POST";
    settings.variable.methodSave = "POST";
}

main();
};
window.DnDRotate = {
loop: function () {
  var that = this;
  that.drawRotated(angleObj.angle);
  if (angleObj.angle == temp) {
    TweenLite.ticker.removeEventListener("tick", that.loop, that, false, 1);
  }
  temp = angleObj.angle;
},
drawRotated: function (degrees) {
  $(".animation_vongquay").css("transform", "rotate(" + degrees + "deg)");
},
AnimationRotate: function (ketqua) {
  var that = this;
  TweenMax.to(angleObj, 5, {
    angle: ketqua,
    delay: 0,
    repeat: 0
  });
  setTimeout(function () {
    TweenLite.ticker.addEventListener("tick", that.loop, that, false, 1);
   
  }, 0);
}
};
const AnimationLucky = function (indexImg,countItems) {
  // ket_qua = (indexImg * (360 / countItems)) + (360 * countItems);
  ket_qua = Math.floor(indexImg * (360 / countItems)) + 360 * 9;
  window.DnDRotate.AnimationRotate(ket_qua);
};
export default dndPromotion;

